//@ts-nocheck
import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  capitalize,
  formatPhoneNumber,
  formatZipCode,
} from "../../utils/formatUtils";
import BusinessForm from "../../components/KYB/IdentityVerfication/forms/BusinessForm";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/types";
import { useNavigate, useParams } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { addBusinessUserData, addBussnissUpdateFlow, getEmailStatus, getRegisterdInvestors, registerUser } from "../../redux/slice/userSlice";
import { useEffect, useState, useTransition } from "react";
import ButtonComponents from "../../components/commonComponents/ButtonComponents";
import { useAuth } from "../../services/AuthContext";
import { businessValidationSchema } from "../../components/KYB/IdentityVerfication/formData";
import moment from "moment";


export const KybIndentityVerification = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { instance } = useMsal()
  const { userData, bussinessUserdata, isBusinessUpdate } = useSelector((state: RootState) => state.user);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isPending, startTransition] = useTransition();
  const { businesscategory } = useSelector((state: any) => state.business);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({
  });
  const { investorId } = useAuth()
  const { id } = useParams()

  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    if (investorId) {
      localStorage.setItem('investorId', investorId?.investorId
      )
    }
  }, [investorId])

  const handleErrorData = (profile) => {
    if (!id || isBusinessUpdate) return;
    let errorDataBusiness: any = {};
    let touchedDataBusiness: any = {};
    // Handle profile.Responses as string or object
    let reasonObj: any = {};
    try {
      reasonObj = typeof profile.Responses === "string"
        ? JSON.parse(profile.Responses)
        : profile.Responses || {};
    } catch (err) {
      console.error("Invalid JSON in profile.Responses");
    }
    // Mapping external field names to Formik field keys
    const fieldMapping: Record<string, string> = {
      email: "Email",
      ein: "IdNumber",
      business: "BusinessName",
      address: "DeliveryLine",
    };
    const message = reasonObj?.message || "";
    const requiredDocs = profile?.DocumentRequiredFor || "";

    // Parse the "field:message" style
    if (typeof message === "string" && message.includes(":")) {
      const [field, msg] = message.split(":");
      const fieldKey = field.trim().toLowerCase();
      const formikKey = fieldMapping[fieldKey];

      if (formikKey) {
        errorDataBusiness[formikKey] = msg.trim();
        touchedDataBusiness[formikKey] = true;
      }
    }
    // If there are DocumentRequiredFor errors
    if (requiredDocs !== "") {
      errorDataBusiness = {
        IdNumber: requiredDocs.includes("ein") ? "EIN did not match" : requiredDocs.includes("business") || requiredDocs.includes("address") ? true : "",
        BusinessName: requiredDocs.includes("business") ? "Business Name did not match" : "",
        DeliveryLine: requiredDocs.includes("address") ? "Address did not match" : "",
      };
      // Clean out empty values
      touchedDataBusiness = {
        IdNumber: !requiredDocs.includes("ein") || !requiredDocs.includes("business") || !requiredDocs.includes("address") || businessFormik.values.IdNumber === "",
        BusinessName: !requiredDocs.includes("business") || businessFormik.values.BusinessName === "",
        DeliveryLine: !requiredDocs.includes("address") || businessFormik.values.DeliveryLine === "",
      };
    } else {
      errorDataBusiness = {
        ...errorDataBusiness,
        IdNumber: "EIN number is required.",
      };
      // Fallback if no DocumentRequiredFor data
      touchedDataBusiness = {
        ...touchedDataBusiness,
        ...businessFormik.touched,
        IdNumber: true,
      };
    }


    setErrors(errorDataBusiness)
    // Apply to formik
    businessFormik.setErrors(errorDataBusiness);
    businessFormik.setTouched(touchedDataBusiness);

  };
  useEffect(() => {
    userData.purchaseProfile.forEach((profile: any) => {
      if (profile.InvestorId == id) {
        handleErrorData(profile)
        let subCategory: any; // Default to 0 if no subcategory found
        let category: any;
        const categoryId =
          businesscategory &&
          businesscategory?.filter(
            (typeId: any) =>
              typeId.categoryName ===
              profile.BusinessDetailsResponse.Category
          );
        // Check if categoryId is valid (not empty) before proceeding
        if (categoryId?.length > 0) {
          category = categoryId[0];
          // Attempt to find the subcategory based on the user's subcategory name
          if (category && category?.children) {
            const foundSubCategory = category?.children?.filter(
              (typeId: any) =>
                typeId?.id ===
                profile.BusinessDetailsResponse.BusinessCategoryId
            );

            // If a subcategory is found, use its ID
            if (foundSubCategory && foundSubCategory?.length > 0) {
              subCategory = {
                value: foundSubCategory[0]?.id,
                label: foundSubCategory[0]?.categoryName,
              };
            }
          }
        }

        businessFormik.setValues({
          ...profile,
          parentInvestorId: parseInt(localStorage.getItem('investorId')),
          profileName: profile.ProfileName,
          BusinessName: profile?.BusinessDetailsResponse?.BusinessName || '',
          BusinessTypeId: profile?.BusinessDetailsResponse?.BusinessTypeId || 0,
          BusinessCategoriesId: category?.id || 0,
          subCategory: subCategory?.value || 0,
          Email: profile?.Email || '',
          Phone: formatPhoneNumber(profile?.Phone),
          DeliveryLine: profile?.DeliveryLine || '',
          City: capitalize(profile?.City) || '',
          State: profile?.State || '',
          Country: profile?.Country || 'US',
          ZipCode: formatZipCode(profile?.ZipCode),
          IdNumber: '',
          BusinessWebsite: profile?.BusinessDetailsResponse?.BusinessWebsite || '',
          UserType: 'business',
          OperatingAs: profile?.BusinessDetailsResponse?.OperatingAs || '',
          SignupEmail: instance.getActiveAccount()?.idTokenClaims?.email || sessionStorage.getItem('impersonateEmail') || userData?.email,
          investorId: parseInt(id) || 0,
          RegistrationDate: moment(profile?.RegistrationDate).format("YYYY-MM-DD"),
          RegistrationState: profile?.RegistrationState || profile?.BusinessDetailsResponse?.RegistrationState,
        });
      }
    })
  }, [userData, id])
  const [selectedValue, setSelectedValue] = useState("business");

  const normalizeBusinessData = (data: any) => ({
    parentInvestorId: parseInt(localStorage.getItem('investorId')),
    profileName: data?.profileName,
    BusinessName: data?.BusinessName || '',
    BusinessTypeId: data?.BusinessTypeId || 0,
    BusinessCategoriesId: data?.BusinessCategoriesId || 0,
    subCategory: data?.subCategory,
    Email: data?.Email || '',
    Phone: formatPhoneNumber(data?.Phone),
    DeliveryLine: data?.DeliveryLine || '',
    City: capitalize(data?.City) || '',
    State: data?.State || '',
    Country: data?.Country || 'US',
    ZipCode: formatZipCode(data?.ZipCode),
    IdNumber: data?.IdNumber?.replace(/\D/g, ''),
    BusinessWebsite: data?.BusinessWebsite || '',
    UserType: 'business',
    OperatingAs: data?.OperatingAs || '',
    SignupEmail: instance.getActiveAccount()?.idTokenClaims?.email || sessionStorage.getItem('impersonateEmail') || userData?.email,
    investorId: parseInt(id) || 0,
    RegistrationDate: moment(data?.BusinessDetailsResponse?.RegistrationDate).format("YYYY-MM-DD"),
    RegistrationState: data?.RegistrationState || data?.BusinessDetailsResponse?.RegistrationState,
    existingInvestorId : 0
  });


  const businessFormik = useFormik({
    initialValues: {
      profileName: "",
      Email: "",
      Phone: "",
      DeliveryLine: "",
      DeliveryLine2: "",
      City: "",
      State: "",
      Country: "US",
      ZipCode: "",
      IdNumber: "",
      BusinessName: "",
      BusinessTypeId: 0,
      BusinessCategoriesId: 0,
      OperatingAs: "",
      BusinessWebsite: "",
      UserType: "business",
      subCategory: 0,
      RegistrationDate: null,
      RegistrationState: "",
    },
    validationSchema: businessValidationSchema,
    validateOnMount: false,
    validateOnChange: true,
    onSubmit: async (values) => {
      const normalizedData = normalizeBusinessData(values);
      try {
        const data = {
          ...normalizedData,
          type: "business"
        };

        startTransition(async () => {
          await dispatch(addBusinessUserData(data));

          if (!id) {
            setIsLoading(true);
            // const IsInvestorAvailable = await dispatch(getEmailStatus(data.Email)).unwrap();
            setIsLoading(false);

            // if (IsInvestorAvailable) {
            //   setDialogOpen(false);
            //   const errorData = {
            //     ...businessFormik.errors,
            //     Email: "Email address is already in use",
            //   };
            //   businessFormik.setErrors(errorData);
            // } else {
            navigate("/purchaseprofile/identity-verification/business-info");
            // }
          } else {
            dispatch(addBussnissUpdateFlow(true))
            navigate(`/purchaseprofile/identity-verification/business-info/${id}`);
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    if (bussinessUserdata?.UserType === "business") {
      businessFormik.setValues({
        ...bussinessUserdata,
        Email: bussinessUserdata?.Email || activeAccount?.idTokenClaims?.email || sessionStorage.getItem('impersonateEmail') || "",
        Phone: bussinessUserdata?.Phone || activeAccount?.idTokenClaims?.extension_phoneNumber || "",
        DeliveryLine: bussinessUserdata?.DeliveryLine ?? "",
        City: bussinessUserdata?.City ?? "",
        State: bussinessUserdata?.State ?? "",
        Country: bussinessUserdata?.Country ?? "US",
        ZipCode: bussinessUserdata?.ZipCode ?? "",
        IdNumber: bussinessUserdata?.IdNumber ?? "",
        BusinessName: bussinessUserdata?.BusinessName ?? "",
        BusinessTypeId: bussinessUserdata?.BusinessTypeId ?? 0,
        BusinessCategoriesId: bussinessUserdata?.BusinessCategoriesId ?? 0,
        OperatingAs: bussinessUserdata?.OperatingAs ?? "",
        BusinessWebsite: bussinessUserdata?.BusinessWebsite ?? "",
        UserType: "business",
        RegistrationDate: moment(bussinessUserdata?.RegistrationDate).format("YYYY-MM-DD"),
        RegistrationState: bussinessUserdata?.RegistrationState,
      });
    } else if (!id && activeAccount && activeAccount?.idTokenClaims) {
      businessFormik.setFieldValue(
        "Email",
        activeAccount?.idTokenClaims?.email || userData?.email || sessionStorage.getItem('impersonateEmail') || ""
      );
      businessFormik.setFieldValue(
        "Phone",
        activeAccount?.idTokenClaims?.extension_phoneNumber ||
        userData?.phone ||
        ""
      );
    }
  }, [bussinessUserdata, instance]);

  useEffect(() => {
    businessFormik.validateForm();
  }, [businessFormik.values]);

  const validateBeforeSubmit = async () => {
    startTransition(async () => {
      businessFormik.setTouched(
        Object.keys(businessFormik.values).reduce((acc, field) => {
          acc[field] = true;
          return acc;
        }, {})
      );

      const errors = await businessFormik.validateForm();

      if (Object.keys(errors).length) {
        businessFormik.setErrors(errors);
      } else {
        businessFormik.handleSubmit();
      }
    });
  };

  const handleBusinessPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const { name } = e.target as HTMLInputElement;
    let pastedValue = e.clipboardData.getData('Text');
    if (name === 'Phone' || name === 'phone') {
      pastedValue = pastedValue.replace(/\D/g, '').slice(0, 10);
      let formatted = pastedValue;
      if (pastedValue.length >= 3) {
        formatted = `(${pastedValue.slice(0, 3)})`;
        if (pastedValue.length >= 6) {
          formatted += ` ${pastedValue.slice(3, 6)}`;
          if (pastedValue.length >= 10) {
            formatted += `-${pastedValue.slice(6, 10)}`;
          } else {
            formatted += pastedValue.slice(6);
          }
        } else {
          formatted += ` ${pastedValue.slice(3)}`;
        }
      }
      businessFormik.setFieldValue(name, formatted);
      e.preventDefault();
      return;
    } else if (name === 'ZipCode') {
      pastedValue = pastedValue.replace(/\D/g, '').slice(0, 9);
      let formatted = pastedValue;
      if (pastedValue.length > 5) {
        formatted = `${pastedValue.slice(0, 5)}-${pastedValue.slice(5, 9)}`;
      }
      businessFormik.setFieldValue(name, formatted);
      e.preventDefault();
      return;
    } else if (name === 'IdNumber') {
      pastedValue = pastedValue.replace(/\D/g, '').slice(0, 9);
      let formatted = pastedValue;
      if (pastedValue.length > 2) {
        formatted = `${pastedValue.slice(0, 2)}-${pastedValue.slice(2)}`;
      }
      businessFormik.setFieldValue(name, formatted);
      e.preventDefault();
      return;
    } else if (name === 'City') {
      pastedValue = pastedValue.replace(/[^a-zA-Z\s'-]/g, '').slice(0, 40);
      businessFormik.setFieldValue(name, pastedValue);
      e.preventDefault();
      return;
    } else if (name === 'DeliveryLine' || name === 'BusinessName' || name === 'OperatingAs' || name === 'BusinessWebsite') {
      pastedValue = pastedValue.slice(0, 40);
      businessFormik.setFieldValue(name, pastedValue);
      e.preventDefault();
      return;
    }
    // Default: just set the value
    businessFormik.setFieldValue(name, pastedValue);
    e.preventDefault();
  };

  return (
    <>
      <BusinessForm
        formik={businessFormik}
        values={businessFormik.values}
        errors={{ ...businessFormik.errors, ...errors }}
        touched={businessFormik.touched}
        ispurchaseprofile={window.location.pathname.includes('purchaseprofile')}
        data-testid="business-form"
        size='big'
        setErrors={setErrors}
        BusinessTypeIdValue={businessFormik.values.BusinessTypeId}
        handlePaste={handleBusinessPaste}
      />
      <div className="flex justify-center mt-6" data-testid="submit-button-container">
        <ButtonComponents
          onClick={validateBeforeSubmit}
          label={selectedValue === "individual" ? "Submit" : "Next"}
          variant="contained"
          sx={{
            fontSize: 14,
            borderRadius: "9px",
            backgroundColor:
              (!businessFormik.isValid || !businessFormik.dirty)
                ? "#9fa4ab"
                : "#FF5C39",
            color: "#fff",
            border: (!businessFormik.isValid || !businessFormik.dirty)
              ? "1px solid transparent"
              : undefined,
            boxShadow: (!businessFormik.isValid || !businessFormik.dirty)
              ? "none" : undefined,
            '&:hover': {
              backgroundColor:
                (!businessFormik.isValid || !businessFormik.dirty)
                  ? "#9fa4ab"
                  : "#e65232",
              border: (!businessFormik.isValid || !businessFormik.dirty)
                ? "1px solid transparent"
                : undefined,
              boxShadow: (!businessFormik.isValid || !businessFormik.dirty)
                ? "none" : undefined,
            },
          }}
          datatestid="submit-button"
        />
      </div>
    </>
  );
};